<template>
  <div class="padding-9">
    <div class="typed-on-paper-a4">
      <h1 class="text-align-center">Pilot and Mission Database (PAM)</h1>
        <p class="text-align-center">Welcome to the Pilot and Mission Database, nicknamed PAM for short.</p>
          <h1 class="heading">Office</h1>
          <p class="text-align-left">
            The Office is the main page for our Pilot and Mission Database.
            Here you can select the various pages that present the relevant information about our group's operations.
          </p>
          <p>
            In future, this will be the main hub for you to select the various elements that we hope will comprise our database.
            Such things may or may not include Personal Pilot's Diaries, Logbooks, Display Cases for Awards and Citations,
            as well as the relevant paperwork that accompanied these things during the 1940s.
          </p>
          <p>
            As with any new venture such as this, we hope you will bear with us with the inevitable issues that will present themselves.
            You may report bugs, or make suggestions by using the link at the bottom of the page.
          </p>
      <DivLinkButton
        class="padding-0-10"
        route-name="AboutUS"
      >
        <h1 class="heading">Documentation</h1>
        <p class="text-align-left">
          This page contains useful information about our Standard Operating Procedures (SOPs), Rules and helpful Guides to ready you for the FTC Campaign experience.
        </p>
      </DivLinkButton>

      <DivLinkButton
        class="padding-0-10"
        route-name="CampaignList"
      >
        <h1 class="heading">Campaigns</h1>
        <p class="text-align-left">
        The Campaigns page is the centralised location for everything that the "Flying Tin Cans" do with regards to our
          historical Campaigns. General Campaign information, Briefings and After Action Reports (AARs) can be found here.
        </p>
      </DivLinkButton>

      <DivLinkButton
        class="padding-0-10"
        route-name="Units"
      >
        <h1 class="heading">Rosters</h1>
        <p class="text-align-left">
          This page is where all information about the actual "Tin Cans" can be found, the Units that make up our group.
          Here you will find Unit Rosters, as well as information about which Historical Squadron each Unit is
          currently representing.
        </p>
      </DivLinkButton>

<!--      <DivLinkButton-->
<!--        class="padding-0-10"-->
<!--        route-name="Members"-->
<!--      >-->
<!--        <h1 class="heading">Members</h1>-->
<!--        <p class="text-align-left">-->
<!--          The Members page provides all information pertaining to our Members.-->
<!--          Everything from our "Length of Service" to our persistent pilot characters can be found here.-->
<!--        </p>-->
<!--      </DivLinkButton>-->

      <DivLinkButton
        class="padding-0-10"
        route-name="UnitOverview"
      >
        <h1 class="heading">Administration</h1>
        <p class="text-align-left">
          This part of our Pilot and Mission Database is meant for our paper pushers who administer the daily
          comings and goings of our Members.
        </p>
      </DivLinkButton>
      <p class="text-align-left">
        We would like to thank Thaine for creating this tool, and for helping us set it up.
      </p>
<!--      <p class="text-align-right"><img class="homeStamp" src="../assets/images/logo-stamp.png"/></p>-->
    </div>
    </div>





    <!--<iframe id="ytplayer" type="text/html" width="100%" height="400px" src="https://www.youtube.com/embed/v6u4JxgE2S4?autoplay=0&origin=http://aircombatgroup.co.uk"-->
            <!--frameborder="0"></iframe>-->
  </div>
</template>

<script>
import he from 'he'
import DivLinkButton from './basic_comp/DivLinkButton'

export default {
  name: 'Home',
  components: {
    DivLinkButton
  },
  async mounted () {

    console.log("Testing PHP connection")
    // this.$store.commit('logger/addEntry', {message: "Testing PHP connection"})
    this.$dbCon.requestViewData(this.$options.name, {view: "member_info_with_last_status", member_status: 0})
      .then((response) => {
        console.log("PHP connection test, response received.");
        // this.$store.commit('logger/addEntry', {message: "PHP connection test, response received."});
        this.number_members = response.length;
      })
      .catch((error) => {
        console.log("PHP connection test, error ");
        // this.$store.commit('logger/addEntry', {message: "PHP connection test, error."});
        console.log(error.message);

      });

    console.log("Starting store testing");
    console.log("Calling getter: " + this.$store.getters['test/doubleCount'])
    console.log("Calling mutation: ")
    this.$store.commit('test/increment')
    console.log("Calling getter: " + this.$store.getters['test/doubleCount'])

    await this.$auth.syncSession(this.$options.name);
    console.log("he-version: "+he.version);

  },
  data () {

    return {

      number_members: null
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.homeImage {
  max-height: 400px;
}

.homeStamp {
  max-height: 150px;
  padding-right: 65px;
  padding-top: 65px;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue